// Module
var code = "<div id=\"{{id}}\" class=\"{{class}}\"> <div class=\"box\"></div> </div>";
// Exports
module.exports = code;